import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "../components/CartContext";
import "../styles/Cos.css";
import "../styles/checkoutsidebar.css";
const Cos = () => {
  const { cartItems, removeFromCart, updateCartItemQuantity } =
    useContext(CartContext);
  if (cartItems.length === 0) {
    return (
      <div className="empty-cart-message">
        <div className="empty-message">
          <i className="fa-solid fa-check"></i>
          <p>Am actualizat coșul.</p>
        </div>
        <p>Coșul tău este în prezent gol.</p>

        <Link to="/" className="btn continue-shopping-btn">
          Continuă cumpărăturile
        </Link>
      </div>
    );
  }
  const calculateItemTotal = (price, quantity) => price * quantity;
  return (
    <div className="cart-container">
      <h1 className="heading-secondary">Coșul de cumpărături</h1>
      <table className="shop-table">
        <thead>
          <tr>
            <th className="product-name">Produs</th>
            <th className="product-price">Preț</th>
            <th className="product-quantity">Cantitate</th>
            <th className="product-subtotal">Total</th>
            <th className="product-delete">Șterge</th>
          </tr>
        </thead>
        <tbody>
          {cartItems.map((item) => (
            <React.Fragment key={item.id}>
              <tr className="cart-row">
                <td className="cart-product">
                  <div className="cart-product-details">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="cart-product-image"
                    />
                    <span>{item.name}</span>
                  </div>
                </td>
                <td className="cart-price">{item.price} lei</td>
                <td className="cart-quantity">
                  <button
                    className="quantity-btn minus-btn"
                    onClick={() => {
                      if (item.quantity === 1) {
                        removeFromCart(item.id);
                      } else {
                        updateCartItemQuantity(item.id, item.quantity - 1);
                      }
                    }}
                  >
                    −
                  </button>
                  <span>{item.quantity}</span>
                  <button
                    className="quantity-btn plus-btn"
                    onClick={() =>
                      updateCartItemQuantity(item.id, item.quantity + 1)
                    }
                  >
                    +
                  </button>
                </td>
                <td className="cart-total">
                  {calculateItemTotal(item.price, item.quantity)} lei
                </td>
                <td className="cart-delete">
                  <i
                    className="fa-solid fa-trash cart-delete-icon"
                    onClick={() => removeFromCart(item.id)}
                  ></i>
                </td>
              </tr>
              {item.extras &&
                item.extras.map((extra) => (
                  <tr key={extra.id} className="cart-extra">
                    <td className="cart-product">
                      <div className="cart-product-details extra-padding">
                        <img
                          src={extra.image}
                          alt={extra.name}
                          className="cart-product-image"
                        />
                        <span>{extra.name} </span>
                      </div>
                    </td>
                    <td className="cart-price">{extra.price} lei</td>
                    <td className="cart-quantity">1</td>
                    <td className="cart-total">{extra.price} lei</td>
                    <td className="cart-delete">
                      <i
                        className="fa-solid fa-trash cart-delete-icon"
                        onClick={() => removeFromCart(item.id, extra.id)}
                      ></i>
                    </td>
                  </tr>
                ))}
              {item.greetingText && (
                // <tr className="cart-greeting">
                //   <td colSpan="5" className="cart-greeting-text">
                //     <strong>Text pentru felicitare:</strong> {item.greetingText}
                //   </td>
                // </tr>
                <tr className="cart_item greeting-text">
                  <strong>Text pentru felicitare: </strong>
                  <td colSpan="5" className="product-name">
                    <div className="greeting-section-box">
                      <p className="greeting-text-written">
                        {item.greetingText}
                      </p>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="cart-delivery">
                <td colSpan="5" className="cart-delivery-info">
                  <p className="delivery-date">
                    <strong> Data de livrare:</strong> {item.deliveryDate}
                  </p>
                  <p className="delivery-time">
                    <strong>Ora: </strong> {item.deliveryTime}
                  </p>
                </td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <div className="cart-summary">
        <div className="summary-container">
          <div className="summary-row-first">
            <span className="total-label">Total pentru plată:</span>
            <span className="total-price">
              {cartItems.reduce(
                (acc, item) =>
                  acc +
                  calculateItemTotal(item.price, item.quantity) +
                  (item.extras
                    ? item.extras.reduce((sum, extra) => sum + extra.price, 0)
                    : 0),
                0
              )}{" "}
              lei
            </span>
          </div>
          <div className="summary-row">
            <p className="delivery-text">
              Costul de transport va fi adăugat după alegerea orașului pentru
              livrare.
            </p>
            <Link to="/checkout" className="btn checkout-btn">
              Continua cu finalizarea comenzii
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Cos;
